import gql from 'graphql-tag';

export const getTenantChannelInfoByUser = gql`
  query getTenantChannelInfoByUser($userId: UUID!, $channelId: UUID!) {
    tenantChannelsByUser(userId: $userId, channelId: $channelId) {
      id
      name
    }
  }
`;

